// forEach method, could be shipped as part of an Object Literal/Module
export const forEach = function (array, callback, scope) {
  for (let i = 0; i < array.length; i++) {
    callback.call(scope, i, array[i]);
  }
};
